require('./src/angular-youtube-embed');
module.exports = 'youtube-embed';



//////////////////
// WEBPACK FOOTER
// ./~/angular-youtube-embed/index.js
// module id = 453
// module chunks = 36